/* marca-2 (#741 y #742, 27-oct-2026): EL AVISO DE LA MUDANZA A QUIZESSA.COM.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Un renglon arriba del Panel, encima del saludo, con el fondo y el borde del aviso gris de la
   casa, sin boton y sin X. Sale SOLO en la web y SOLO cuando la pagina vive en studybuddy.vc
   (o www.studybuddy.vc): en quizessa.com no se pinta nunca, asi que desaparece solo el dia que
   Carlos encienda la redireccion (#744). En la app no sale (la app no cambia de dominio para el
   usuario). La cuenta registrada lee que tendra que iniciar sesion de nuevo; el invitado, que
   cree su cuenta antes (textos ratificados por Carlos el 26-oct, letra por letra).

   El contenedor compensa el espacio entre bloques del Panel (18 en el telefono, 28 desde 768):
   el saludo baja exactamente la altura del aviso y nada mas. Recibe la `t` del Panel, como sus otras
   piezas (`TarjetaParaAgregar`). */
import React from 'react';
import { IS_APP_BUILD } from '../../lib/buildTarget';
import { X } from 'lucide-react';
import { TONOS_DEL_AVISO } from './AvisoDelPanel';
import { useAvisoMarca, LLAVE_TEXTO, LLAVE_CERRAR } from '../../lib/avisoMarca';

export const HOSTS_VIEJOS = ['studybuddy.vc', 'www.studybuddy.vc'];

export const LLAVE_CUENTA = 'dashboard:mudanza.cuenta';
export const LLAVE_INVITADO = 'dashboard:mudanza.invitado';

export function tocaAvisoMudanza(hostname) {
  return !IS_APP_BUILD && HOSTS_VIEJOS.includes(hostname);
}

function hostDeHoy() {
  try {
    return window.location.hostname || '';
  } catch {
    return '';
  }
}

export default function AvisoMudanza({ invitado, t }) {
  if (!tocaAvisoMudanza(hostDeHoy())) return null;
  const c = TONOS_DEL_AVISO.gris;
  return (
    <div className="-mb-[18px] md:-mb-7 pb-3 shrink-0" data-testid="aviso-mudanza">
      <p role="status" className="rounded-xl border px-4 py-2.5 text-[13px] leading-[18px] text-[#9A9A9A] break-words"
        style={{ background: c.fondo, borderColor: c.borde }} data-testid="aviso-mudanza-texto">
        {t(invitado ? LLAVE_INVITADO : LLAVE_CUENTA)}
      </p>
    </div>
  );
}


/* marca-3 (C.2 a, #736): la variante "marca", el aviso de 30 dias "StudyBuddy ahora es Quizessa" (texto
   del ANEXO 1.1, `common.aviso_marca`). Mismo molde y mismo lugar que el de la mudanza, mas una "x" que lo
   cierra para siempre en ese aparato (lib/avisoMarca.js). Sale en la web de quizessa.com y en la app;
   en studybuddy.vc no, porque ahi ya va el de la mudanza (el de arriba), que dice lo mismo y mas. La "x"
   dibuja 16 y su area de toque es de 44 (un span absoluto y centrado, la tecnica de la casa), asi que el
   renglon mide lo mismo que el de la mudanza. */
export function AvisoMarca({ t }) {
  const { mostrar, cerrar } = useAvisoMarca();
  if (!mostrar || tocaAvisoMudanza(hostDeHoy())) return null;
  const c = TONOS_DEL_AVISO.gris;
  return (
    <div className="-mb-[18px] md:-mb-7 pb-3 shrink-0" data-testid="aviso-marca">
      <div className="flex items-start gap-3 rounded-xl border px-4 py-2.5" style={{ background: c.fondo, borderColor: c.borde }}>
        <p role="status" className="flex-1 min-w-0 text-[13px] leading-[18px] text-[#9A9A9A] break-words" data-testid="aviso-marca-texto">
          {t(LLAVE_TEXTO)}
        </p>
        <button type="button" onClick={cerrar} aria-label={t(LLAVE_CERRAR)}
          className="relative shrink-0 flex h-[18px] w-4 items-center justify-center text-[#9A9A9A]" data-testid="aviso-marca-cerrar">
          <span aria-hidden="true" className="absolute left-1/2 top-1/2 h-11 w-11 -translate-x-1/2 -translate-y-1/2" />
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
